import React, { useContext } from "react";
import { useAppSelector } from "../../../hooks/useAppSelector";
import Button, { Link } from "../../Button";
import DadosLojas from "../../DadosLojas";
import "./styles.scss";
import { getUser } from "../../../helpers/user";
import { Cog } from "lucide-react";

export const ContextMenu = React.createContext(null as any);
let usuario;

const FilterAndMenu = () => {
  const [state, setState] = React.useState({ levelsActives: [] } as any);
  usuario = getUser();

  const toggleMenu = (ev) => {
    const {
      currentTarget: { id },
    } = ev;
    const exists = state.levelsActives.findIndex((item) => item === id);
    const levelsActives =
      exists === -1
        ? [...state.levelsActives, id]
        : state.levelsActives.filter((item) => item !== id);
    setState({
      ...state,
      levelsActives,
    });
  };

  const openMenu = (idMenu: string) =>
    state.levelsActives.find((item) => item === idMenu);
  const lojaSelected = useAppSelector((state) => state.getLojas.lojaSelected);
  const disbleMenuMonitoria = !lojaSelected ? "disabled" : "";

  return (
    <div className="wrapper-filter">
      <DadosLojas />
      <ul className="accordion">
        <li className={`accordion__item ${disbleMenuMonitoria}`}>
          <Button
            variant="tertiary"
            size="sm"
            id="menu-pts-monitoria"
            onClick={toggleMenu}
          >
            Pontos de Monitoramento
            <i
              className={`fa-solid fa-chevron-${
                openMenu("menu-pts-monitoria") ? "up" : "down"
              }`}
            ></i>
          </Button>
          {!lojaSelected && (
            <span className="text-helper">Antes selecione a loja desejada</span>
          )}
        </li>
        <ul
          className={`accordion ${openMenu("menu-pts-monitoria") && "active"}`}
        >
          <li className="accordion__item">
            <Link
              to="/pontos-de-monitoramento/visao-detalhada"
              variant="tertiary"
              size="sm"
            >
              Visão Detalhada
            </Link>
          </li>
          <li className="accordion__item">
            <Link
              to="/pontos-de-monitoramento/alertas"
              variant="tertiary"
              size="sm"
            >
              Alertas
            </Link>
          </li>
          {[6, 7, 8, 9, 999].includes(usuario.usuario.nivel) && (
            <li className="accordion__item">
              <Button
                variant="tertiary"
                size="sm"
                id="menu-manutencao"
                onClick={toggleMenu}
              >
                Manutenção
                <i
                  className={`fa-solid fa-chevron-${
                    openMenu("menu-manutencao") ? "up" : "down"
                  }`}
                  style={{ marginLeft: "auto" }}
                ></i>
              </Button>
              <ul
                className={`accordion ${
                  openMenu("menu-manutencao") ? "active" : ""
                }`}
              >
                <li className="accordion__item">
                  <Link
                    to="/manutencao/agendamento"
                    variant="tertiary"
                    size="sm"
                  >
                    Agendamento
                  </Link>
                </li>
                <li className="accordion__item">
                  <Link to="/manutencao/agendadas" variant="tertiary" size="sm">
                    Agendadas
                  </Link>
                </li>
              </ul>
            </li>
          )}
          <li className="accordion__item">
            <Link
              to="/pontos-de-monitoramento/relatorios"
              variant="tertiary"
              size="sm"
            >
              Relatórios
            </Link>
          </li>
          <li className="accordion__item">
            {[7, 8, 999].includes(usuario.usuario.nivel) && (
              <Button
                variant="tertiary"
                size="sm"
                id="menu-configs"
                onClick={toggleMenu}
              >
                Configurações
                <i
                  className={`fa-solid fa-chevron-${
                    openMenu("menu-configs") ? "up" : "down"
                  }`}
                ></i>
              </Button>
            )}
            <ul className={`accordion ${openMenu("menu-configs") && "active"}`}>
              <li className="accordion__item">
                <Link to="/configuracoes/loja" variant="tertiary" size="sm">
                  Configurações da loja
                </Link>
              </li>
              <li className="accordion__item">
                <Link
                  to="/pontos-de-monitoramento/configurar"
                  variant="tertiary"
                  size="sm"
                >
                  Pontos de monitoramento
                </Link>
              </li>
              {[8, 999].includes(usuario.usuario.nivel) && (
                <>
                  <li className="accordion__item disabled">
                    <Link
                      to="/config-ponto-de-monitoria"
                      variant="tertiary"
                      size="sm"
                    >
                      Parâmetros dos dispositivos
                    </Link>
                  </li>
                  <li className="accordion__item disabled">
                    <Link
                      to="/config-ponto-de-monitoria"
                      variant="tertiary"
                      size="sm"
                    >
                      Envio de alertas
                    </Link>
                  </li>
                </>
              )}
            </ul>
          </li>

          <li className="accordion__item">
            <Link
              to="/pontos-de-monitoramento/planta-baixa"
              variant="tertiary"
              size="sm"
            >
              Planta Baixa
            </Link>
          </li>
          <li className="accordion__item">
            {[9].includes(usuario.usuario.nivel) && (
              <Button
                variant="tertiary"
                size="sm"
                id="menu-docs-avcb"
                onClick={toggleMenu}
              >
                Documentação AVCB
                <i
                  className={`fa-solid fa-chevron-${
                    openMenu("menu-docs-avcb") ? "up" : "down"
                  }`}
                ></i>
              </Button>
            )}
            <ul
              className={`accordion ${openMenu("menu-docs-avcb") && "active"}`}
            >
              <li className="accordion__item disabled">
                <Link to="/documentacao-avcb" variant="tertiary" size="sm">
                  Status
                </Link>
              </li>
              <li className="accordion__item">
                <Link to="/documentacao-avcb" variant="tertiary" size="sm">
                  Validação de documentos
                </Link>
              </li>
            </ul>
          </li>
        </ul>
      </ul>
    </div>
  );
};

const OpenedMenu = ({ isOpen }) => {
  usuario = getUser();
  const context = useContext(ContextMenu);

  const [state, setState] = React.useState({ levelsActives: [] } as any);

  const toggleMenu = (ev) => {
    const id = ev.currentTarget.id;
    const exists = state.levelsActives.includes(id);
    const levelsActives = exists
      ? state.levelsActives.filter((item) => item !== id)
      : [...state.levelsActives, id];

    setState({ ...state, levelsActives });
  };

  const openMenu = (idMenu: string) =>
    state.levelsActives.find((item) => item === idMenu);

  return (
    <aside className={`menu ${isOpen ? "" : "closed"}`}>
      {isOpen ? (
        <FilterAndMenu />
      ) : (
        <ul className="accordion">
          <li className="accordion__item">
            <Button
              variant="tertiary"
              size="sm"
              onClick={() => context.setMenuIsOpen()}
            >
              <i className="fa-solid fa-clipboard"></i>
              Monitoramento
            </Button>
          </li>
        </ul>
      )}
      <ul className="accordion">
        <li className="accordion__item">
          <Link to="/dashboard" variant="tertiary" size="sm">
            <i className="fa-solid fa-chart-simple"></i>
            Dashboard
          </Link>
        </li>
        <li className="accordion__item">
          {[7, 8, 999].includes(usuario.usuario.nivel) && (
            <Link to="/cadastrar-usuarios" variant="tertiary" size="sm">
              <i className="fa-solid fa-sheet-plastic"></i>
              Cadastrar usuários
            </Link>
          )}
        </li>
        <li className="accordion__item">
          {[999].includes(usuario.usuario.nivel) && (
            <>
              <Button
                variant="tertiary"
                size="sm"
                id="menu-tecnico-submenu"
                onClick={toggleMenu}
              >
                <i className="fa-solid fa-sheet-plastic"></i>
                Tecnico
                <i
                  className={`fa-solid fa-chevron-${
                    openMenu("menu-tecnico-submenu") ? "up" : "down"
                  }`}
                  style={{ marginLeft: "auto" }}
                ></i>
              </Button>

              <ul
                className={`accordion ${openMenu("menu-tecnico-submenu") && "active"}`}
              >
                <li className="accordion__item">
                  <Link to="/tecnico/comandos" variant="tertiary" size="sm">
                    Comandos da Placa
                  </Link>
                </li>
                <li className="accordion__item">
                  <Link
                    to="/tecnico/processo-criacao"
                    variant="tertiary"
                    size="sm"
                  >
                    Processo de Criação
                  </Link>
                </li>
              </ul>
            </>
          )}
        </li>
        <li className="accordion__item">
          <Link to="/relatorios" variant="tertiary" size="sm">
            <i className="fa-solid fa-sheet-plastic"></i>
            Relatórios
          </Link>
        </li>
        <li className="accordion__item">
          {[7, 8, 999].includes(usuario.usuario.nivel) && (
            <Link to="/property" variant="tertiary" size="sm">
              Property
            </Link>
          )}
        </li>
        <li className="accordion__item">
          <Link to="/perfil" variant="tertiary" size="sm">
            Meu Perfil
          </Link>
        </li>
      </ul>
    </aside>
  );
};

const Menu = ({ isOpen }: any) => <OpenedMenu isOpen={isOpen} />;

export default Menu;
